import * as angular from 'angular';
import * as _ from 'lodash';

import { IDomainSearchService } from '../../services/data/domainSearch.service';
import { DomainUserDto } from '../../services/data/DomainUserDto';
import { ComponentDefinition, IUserModel } from '../../models';


class DomainUserSelectorController implements angular.IComponentController {
    change: () => void;
    formController: angular.IFormController;
    isLoading: boolean;
    isPopoverOpen: boolean;
    loadingMessage: string;
    model: IUserModel;
    name: string;
    startOpen: boolean;
    users: any[];

    // For research
    selectedItem: DomainUserDto;
    criteria: any[];
    searchString: string;
    searchResults: DomainUserDto[] = [];

    static $inject = ['$scope', '$timeout', 'domainSearchService'];

    constructor(private _$scope: angular.IScope,
        private _$timeout: angular.ITimeoutService,
        private _domainSearchService: IDomainSearchService) {

        this.criteria = [
            {
                label: 'Login',
                isMatch: () => true,
                model: 'u',
                placeholder: 'User name',
                property: 'u'
            },
            {
                label: 'First name',
                isMatch: () => true,
                model: 'fn',
                placeholder: 'Search pattern on first name',
                property: 'fn'
            },
            {
                label: 'Last name',
                isMatch: () => true,
                model: 'ln',
                placeholder: 'Search pattern on last name',
                property: 'ln'
            },
            {
                label: 'Email',
                isMatch: () => true,
                model: 'em',
                placeholder: 'Search pattern on email',
                property: 'em'
            }
        ];
    }

    $onInit() {
        this._$scope.$watch(() => this.selectedItem, (newValue: DomainUserDto) => {
            if (newValue) {
                this.updateModel(newValue);
            }
        });

        this._$scope.$watch(() => this.searchString, (newValue) => {
            if (newValue) {
                this.search();
            } else {
                this.searchResults = [];
            }
        });

        if (this.startOpen) {
            this._$timeout(() => this.isPopoverOpen = true);
        }
    }

    private updateModel(newValue: DomainUserDto) {
        if (this.formController && this.name && newValue.userName !== this.model.domainName) {
            this.model.domainName = newValue.userName;
            this.formController[this.name].$setDirty();
            if ((this.model as any).addFromDomain) {
                // To be tested:
                // Object.assign(this.model, newValue)
                this.model.email = newValue.email;
                this.model.firstName = newValue.firstName;
                this.model.lastName = newValue.lastName;
                this.model.phoneNumber = newValue.phoneNumber;
                this.model.userName = newValue.userName;
            }
            this.isPopoverOpen = false;
            if (this.change) {
                this._$timeout(() => this.change());
            }
        }
    }

    private search() {
        this.isLoading = true;
        this._domainSearchService.search(this.searchString).then(data => {
            this.searchResults = data;
        }).finally(() => {
            this.isLoading = false;
        });
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj.hasOwnProperty('isDisabled')) {
            const isDisabled = changesObj['isDisabled'];
            if (isDisabled.currentValue) {
                this.selectedItem = null;
            }
        }
    }

    clear() {
        if (this.model) {
            this.model.domainName = '';
            this.formController[this.name].$setDirty();
        }
    }
}

export const wtDomainUserSelector: ComponentDefinition = {
    componentId: 'wtDomainUserSelector',
    controller: DomainUserSelectorController,
    template: require('./domainUserSelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '=',
        name: '@?',
        formController: '=?',
        isDisabled: '<?',
        startOpen: '<?',
        change: '&?'
    }
};
